<template>
  <v-dialog :value="value" persistent max-width="700" content-class="importing-dialog" @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="importing-dialog__header white--text">
        <span class="importing-dialog__title">{{ $t('dueDiligence.importingTitle') || 'Importing' }}</span>
        <v-spacer />
        <v-btn icon dark small @click="cancelImport">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="importing-dialog__body pt-8 pb-6">
        <div class="importing-dialog__spinner">
          <div class="importing-dialog__dots">
            <span v-for="i in 12" :key="i" class="importing-dialog__dot" :style="dotStyle(i)" />
          </div>
        </div>
        <p class="importing-dialog__message text-center mt-6 mb-0">
          {{ $t('dueDiligence.importingMessage') || 'We are fetching the report data and synchronizing details with the blockchain. This may take a few moments. You can wait here, or check the status in your Exchange History.' }}
        </p>
      </v-card-text>
      <v-card-actions class="pa-4 pt-0">
        <v-btn
          outlined
          color="primary"
          class="text-none"
          @click="cancelImport"
        >
          {{ $t('dueDiligence.cancelImport') || 'CANCEL IMPORT' }}
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          class="text-none white--text"
          @click="runInBackground"
        >
          {{ $t('dueDiligence.runInBackground') || 'RUN IN BACKGROUND' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ImportDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dotPhase: 0,
      intervalId: null,
    };
  },
  watch: {
    value(visible) {
      if (visible) {
        this.startAnimation();
      } else {
        this.stopAnimation();
      }
    },
  },
  beforeDestroy() {
    this.stopAnimation();
  },
  methods: {
    dotStyle(i) {
      const n = 12;
      const angle = ((i - 1) / n) * Math.PI * 2 + this.dotPhase * 0.5;
      const r = 28;
      const x = 32 + r * Math.cos(angle);
      const y = 32 + r * Math.sin(angle);
      const delay = (i - 1) * 0.08;
      const scale = 0.65 + 0.35 * (0.5 + 0.5 * Math.sin(this.dotPhase * 2 + delay * Math.PI * 2));
      return {
        left: `${x}px`,
        top: `${y}px`,
        animationDelay: `${delay}s`,
        transform: `translate(-50%, -50%) scale(${scale})`,
        opacity: 0.6 + 0.4 * (0.5 + 0.5 * Math.sin(this.dotPhase * 1.5 + delay * 2)),
      };
    },
    startAnimation() {
      this.dotPhase = 0;
      this.intervalId = setInterval(() => {
        this.dotPhase += 0.15;
      }, 80);
    },
    stopAnimation() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    close() {
      this.stopAnimation();
      this.$emit('input', false);
      this.$emit('close');
    },
    cancelImport() {
      this.$emit('cancel');
      this.close();
    },
    runInBackground() {
      this.$emit('run-in-background');
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.importing-dialog__header {
  background-color: #0e7d4a !important;
  padding: 14px 16px;
}

.importing-dialog__title {
  font-weight: 600;
  font-size: 1.1rem;
}

.importing-dialog__body {
  min-height: 200px;
}

.importing-dialog__spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
}

.importing-dialog__dots {
  position: relative;
  width: 64px;
  height: 64px;
}

.importing-dialog__dot {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #00bd73;
  animation: importing-pulse 1s ease-in-out infinite;
}

@keyframes importing-pulse {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

.importing-dialog__message {
  font-size: 0.95rem;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.8);
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

</style>
